'use client';

import React, { useEffect, useRef } from 'react';

interface SlideWrapperProps {
  id: string;
  registerRef: (id: string, el: HTMLElement | null) => void;
  children: React.ReactNode;
  className?: string;
  minHeight?: string;
}

export default function SlideWrapper({ id, registerRef, children, className = '', minHeight = 'min-h-screen' }: SlideWrapperProps) {
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    registerRef(id, ref.current);
    return () => registerRef(id, null);
  }, [id, registerRef]);

  return (
    <section
      ref={ref}
      id={id}
      className={`slide-section relative overflow-hidden ${minHeight} ${className}`}
      style={{ scrollMarginTop: '64px' }}
      suppressHydrationWarning
    >
      {children}
    </section>
  );
}